export default "__VITE_PUBLIC_ASSET__9887efca__"